import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaskLoadingComponent } from './mask-loading/mask-loading.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';






@NgModule({
  declarations: [MaskLoadingComponent],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    FlexLayoutModule
    
  ],
  exports:[MaskLoadingComponent]
  
})
export class MaskLoadingModule { }
